<template>
  <div
    :class="[
      'pdf-controls d-flex flex-column align-items-center justify-content-center',
      buttonsPosition,
    ]"
  >
    <button
      v-if="showFitToggle"
      :title="fit === 'width' ? 'Fit to page' : 'Fit to width'"
      class="btn btn-sm btn-default"
      @click="$emit('toggle-page-fit', fit)"
    >
      <font-awesome-icon :icon="fit === 'width' ? 'compress' : 'expand'" />
    </button>
    <div class="buttons-container">
      <div
        :class="{ focus: doubleButtonFocus }"
        class="double-button d-flex flex-column"
      >
        <button
          class="top d-flex flex-row align-items-center justify-content-center"
          tooltip="Zoom in"
          tooltip-container="information-requests"
          tooltip-placement="left"
          :disabled="value === maxZoom"
          @click="changeZoomFactor(zoomStep)"
          @focus="doubleButtonFocus = true"
          @blur="doubleButtonFocus = false"
        >
          <i-icon
            symbol="medium-add-1"
            :size="20"
            :stroke-width="2"
            :colour="
              value === maxZoom
                ? palette['light-neutral-70']
                : palette['light-neutral-110']
            "
          ></i-icon>
        </button>
        <button
          class="bottom d-flex flex-row align-items-center justify-content-center"
          tooltip="Zoom out"
          tooltip-container="information-requests"
          tooltip-placement="left"
          :disabled="value === minZoom"
          @focus="doubleButtonFocus = true"
          @blur="doubleButtonFocus = false"
          @click="changeZoomFactor(-1 * zoomStep)"
        >
          <i-icon
            symbol="medium-remove-1"
            :size="20"
            :stroke-width="2"
            :colour="
              value === minZoom
                ? palette['light-neutral-70']
                : palette['light-neutral-110']
            "
          ></i-icon>
        </button>
      </div>
      <slot name="extra-buttons"> </slot>
    </div>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: {
    iIcon,
  },
  props: {
    initialFit: {
      type: String,
      default: 'width',
    },
    buttonsPosition: {
      type: String,
      default: 'bottom',
    },
    minZoom: {
      type: Number,
      default: 0.75,
    },
    maxZoom: {
      type: Number,
      default: 10,
    },
    showFitToggle: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Number,
      required: true,
    },
    zoomStep: {
      type: Number,
      default: 0.25,
    },
  },
  data() {
    return {
      fit: this.initialFit,
      doubleButtonFocus: false,
      palette,
    };
  },
  methods: {
    changeZoomFactor(increment) {
      this.$emit('input', increment);
    },
  },
};
</script>

<style lang="scss">
.pdf-controls {
  position: absolute;
  right: 24px;
  width: 40px;
  z-index: 100;

  .double-button {
    $borderRadius: 8px;

    border-radius: $borderRadius;
    margin-bottom: 4px;

    &.focus {
      box-shadow: 0 0 0 3px $light-neutral-70;
    }

    button {
      background: $light-neutral-default;
      border: 0;
      height: 36px;
      box-sizing: border-box;

      &.top {
        border-top-left-radius: $borderRadius;
        border-top-right-radius: $borderRadius;
        border-top: 1px solid $light-neutral-60;
        border-left: 1px solid $light-neutral-60;
        border-right: 1px solid $light-neutral-60;
      }

      &.bottom {
        border-bottom-left-radius: $borderRadius;
        border-bottom-right-radius: $borderRadius;
        border-bottom: 1px solid $light-neutral-60;
        border-left: 1px solid $light-neutral-60;
        border-right: 1px solid $light-neutral-60;
      }

      &:active:hover:not(:disabled),
      &:hover:not(:disabled) {
        background: $light-neutral-30;
      }
    }
  }

  .vue-slider .vue-slider-rail {
    background: $color-dark-blue-40;

    .vue-slider-process {
      background: $color-dark-blue-80;
    }
  }
}
</style>
